export interface IPersonInvoiceModel {
  id: string;
  createdOn: Date;
  invoiceId: string;
  invoiceNumber: string;
  paymentLink: string;
  dueDate: Date | null;
  amount: number;
  invoiceStatus: InvoiceStatus;
  lastActionDate: Date | null;
  paymentResult: PaymentResult | null;
  receiptNumber: string;
  failureReason: string;
  paidDescription: string;
  completionDate: Date | null;
  orderNumber: number;
  paymentType: string;
  paymentLastFour: string;
  institution: string;
  checkNumber: string;
  nameOnCheck: string;
}

export class PersonInvoiceModel {
  id: string;
  createdOn: Date;
  invoiceId: string;
  invoiceNumber: string;
  paymentLink: string;
  dueDate: Date;
  amount: number;
  invoiceStatus: InvoiceStatus;
  lastActionDate: Date;
  paymentResult: PaymentResult;
  receiptNumber: string;
  description: string;
  completionDate: Date;
  orderNumber: number;
  paymentType: string;
  invoiceStatusIcon: string;
  paymentLastFour: string;
  institution: string;
  checkNumber: string;
  nameOnCheck: string;

  constructor(data: IPersonInvoiceModel) {
    this.id = data.id;
    this.createdOn = data.createdOn;
    this.invoiceId = data.invoiceId;
    this.invoiceNumber = data.invoiceNumber;
    this.paymentLink = data.paymentLink;
    this.dueDate = data.dueDate;
    this.amount = data.amount;
    this.invoiceStatus = data.invoiceStatus;
    this.lastActionDate = data.lastActionDate;
    this.paymentResult = data.paymentResult;
    this.receiptNumber = data.receiptNumber;
    this.description = this.getDescription(data);
    this.completionDate = data.completionDate;
    this.orderNumber = data.orderNumber;
    this.paymentType = data.paymentType;
    this.invoiceStatusIcon = this.getInvoiceStatusIcon();
    this.paymentLastFour = data.paymentLastFour;
    this.institution = data.institution;
    this.checkNumber = data.checkNumber;
    this.nameOnCheck = data.nameOnCheck;
  }
  getInvoiceStatusIcon(): string {
    switch (InvoiceStatus[this.invoiceStatus]) {
      case InvoiceStatus.Paid:
        return 'check_circle';
      case InvoiceStatus.Open:
        return 'schedule';
      case InvoiceStatus.Void:
        return 'cancel';
      case InvoiceStatus.OverDue:
        return 'error';
    }
  }
  getDescription(data: IPersonInvoiceModel): string {
    switch (data.paymentResult) {
      case PaymentResult.Success:
        return data.paidDescription;
      case PaymentResult.Failed:
        let result = data.failureReason.replace('_', ' ');
        return result.charAt(0).toUpperCase() + result.slice(1).toLowerCase();
    }
  }
}

export enum InvoiceStatus {
  Paid = 'Paid',
  Open = 'Open',
  Void = 'Void',
  OverDue = 'Past due',
}

export enum PaymentResult {
  Success = 'Success',
  Failed = 'Failed',
}
